import { Component, DestroyRef, inject, OnInit, ViewContainerRef, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from './core/auth/auth.service';
import { Store } from '@ngrx/store';
import * as HubSelectors from 'src/app/store/hub.selector';
import * as HubActions from './store/hub.actions';
import { combineLatest, distinctUntilChanged, map } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { SpinnerComponent } from './shared/ui/spinner/spinner.component';
import { SvgIconComponent } from './shared/ui/svg-icon/svg-icon.component';
import { SidebarComponent } from './side-bar/sidebar.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, AsyncPipe, SpinnerComponent, SvgIconComponent, SidebarComponent]
})
export class AppComponent implements OnInit {
  private auth = inject(AuthService);
  private viewContainerRef = inject(ViewContainerRef);
  private store = inject(Store);

  _destroy: DestroyRef = inject(DestroyRef);

  hubState$ = this.store.select(HubSelectors.getHubState);
  theme$ = this.store.select(HubSelectors.getHubTheme);

  vm$ = combineLatest([this.hubState$, this.theme$]).pipe(
    map(([hubState, theme]) => ({
      hubState,
      theme
    }))
  );

  ngOnInit() {
    this.auth.login();

    setTimeout(async () => {
      const { LazySvgSpriteSheetComponent } =
        await import('./core/lazy-svg-sprite-sheet/lazy-svg-sprite-sheet.component');
      this.viewContainerRef.createComponent(LazySvgSpriteSheetComponent);
    });

    this.auth.isAuthenticated$
      .pipe(takeUntilDestroyed(this._destroy), distinctUntilChanged())
      .subscribe((isAuthenticated) => {
        if (isAuthenticated) this.store.dispatch(HubActions.appInit());
      });
  }

  public logout() {
    this.auth.logout();
  }
}
